import { render, staticRenderFns } from "./chef-loading-card.vue?vue&type=template&id=010d134f"
import script from "./chef-loading-card.vue?vue&type=script&lang=ts"
export * from "./chef-loading-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports